module.exports = __webpack_public_path__ + "static/legends-5-8233b9b833b0ae2320436eee77e0c4ac.jpg";